
export const olimpicMedals = [{
    country: 'Jan',
    gold: 36,
    silver: 38,
    bronze: 36,
    color: "gray"
}, {
    country: 'Feb',
    gold: 51,
    silver: 21,
    bronze: 28,
}, {
    country: 'Mar',
    gold: 23,
    silver: 21,
    bronze: 28,
}, {
    country: 'Apr',
    gold: 19,
    silver: 13,
    bronze: 15,
}, {
    country: 'May',
    gold: 51,
    silver: 21,
    bronze: 28,
}, {
    country: 'June',
    gold: 23,
    silver: 21,
    bronze: 28,
}, {
    country: 'Jul',
    gold: 19,
    silver: 13,
    bronze: 15,
}, {
    country: 'Aug',
    gold: 23,
    silver: 21,
    bronze: 28,
}, {
    country: 'Sep',
    gold: 19,
    silver: 13,
    bronze: 15,
}, {
    country: 'Oct',
    gold: 51,
    silver: 21,
    bronze: 28,
}, {
    country: 'Nov',
    gold: 23,
    silver: 21,
    bronze: 28,
}, {
    country: 'Dec',
    gold: 19,
    silver: 13,
    bronze: 15,
}];


export const energyConsumption = [
    {
        country: 'Jan', coal: 30, nuclear: 55,
    }, {
        country: 'Feb', coal: 40, nuclear: 50,
    }, {
        country: 'Mar', coal: 25, nuclear: 35,
    }, {
        country: 'Apr', coal: 45, nuclear: 70,
    }, {
        country: 'May', coal: 30, nuclear: 35,
    }, {
        country: 'Jun', coal: 48, nuclear: 52,
    }, {
        country: 'Jul', coal: 28, nuclear: 32,
    }, {
        country: 'Aug', coal: 35, nuclear: 45,
    }, {
        country: 'Sep', coal: 25, nuclear: 30,
    }, {
        country: 'Oct', coal: 55, nuclear: 65,
    }, {
        country: 'Nov', coal: 40, nuclear: 45,
    }, {
        country: 'Dec', coal: 50, nuclear: 60,
    }];


export const mangoConsumption = [
    {
        country: 'Jan', coal: 30, nuclear: 55, mango: 20
    }, {
        country: 'Feb', coal: 40, nuclear: 50, mango: 25
    }, {
        country: 'Mar', coal: 25, nuclear: 35, mango: 30
    }, {
        country: 'Apr', coal: 45, nuclear: 70, mango: 45
    }, {
        country: 'May', coal: 30, nuclear: 35, mango: 15
    }, {
        country: 'Jun', coal: 48, nuclear: 52, mango: 38
    }, {
        country: 'Jul', coal: 28, nuclear: 32, mango: 25
    }, {
        country: 'Aug', coal: 35, nuclear: 45, mango: 35
    }, {
        country: 'Sep', coal: 25, nuclear: 30, mango: 18
    }, {
        country: 'Oct', coal: 55, nuclear: 65, mango: 24
    }, {
        country: 'Nov', coal: 40, nuclear: 45, mango: 37
    }, {
        country: 'Dec', coal: 50, nuclear: 60, mango: 48
    }];


export const spaceConsumption = [
    {
        country: 'Jan', coal: 10, nuclear: 15, mango: 8, space: 10, 
    }, {
        country: 'Feb', coal: 14, nuclear: 10, mango: 12, space: 20
    }, {
        country: 'Mar', coal: 5, nuclear: 15, mango: 13, space: 14
    }, {
        country: 'Apr', coal: 13, nuclear: 20, mango: 15, space: 22
    }, {
        country: 'May', coal: 10, nuclear: 15, mango: 25, space: 8
    }, {
        country: 'Jun', coal: 18, nuclear: 12, mango: 18, space: 18
    }, {
        country: 'Jul', coal: 18, nuclear: 22, mango: 20, space: 8
    }, {
        country: 'Aug', coal: 15, nuclear: 10, mango: 5, space: 30
    }, {
        country: 'Sep', coal: 5, nuclear: 20, mango: 8, space: 12
    }, {
        country: 'Oct', coal: 25, nuclear: 15, mango: 10, space: 15
    }, {
        country: 'Nov', coal: 20, nuclear: 24, mango: 17, space: 30
    }, {
        country: 'Dec', coal: 30, nuclear: 6, mango: 4, space: 10
    }];


